/**
 * Local and smrx-dev environment configuration
 */
import type { Config } from './default';

const config: Partial<Config> = {
  descope: {
    // Dev/local environment
    pharmacyPortal: {
      flowId: 'sign-in-developers-lower-environment-portals',
      tenant: 'smithrx-internal',
    },
    projectId: 'P2nTyciI8Isg0mgRxyiiyVcpbZph',
  },
  isProduction: false,
  services: {
    api: '/api',
  },
  statsig: {
    // Client-side SDK key for development environment
    sdkKey: 'client-CpmbFCsT8me2J0Bx7kaBJLIoGLW6mADju7eCms5wnLR',
    environment: 'development',
    api: undefined, // handover to sdk
    eventLoggingApi: undefined, // handover to sdk
  },
};

export default config;
